module.exports = __webpack_public_path__ + "img/IAR2.bb10b96d.png";